import {
  adaptCollectionToApi,
  adaptCollectionToStore,
  adaptCollectionsToStore,
} from './adapters/collectionAdapter'

import { CONTENT_BACKOFFICE, CONTENT } from '@/services/axios.config'
import { buildHeaders } from './utils/build_headers'
import buildParamList, { omitByEmptyKeepBooleans } from './utils/build_params'
import { buildServices } from './utils/build_services'
import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

const services = [
  {
    name: 'listCollections',
    method: 'get',
    url: (params) => `/collections${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptCollectionsToStore,
  },
  {
    name: 'getCollection',
    method: 'get',
    url: (params) => `/collections/${params.collectionId}`,
    resolver: adaptCollectionToStore,
  },
  {
    name: 'createCollection',
    method: 'post',
    url: () => `/collections`,
    data: (params) => {
      return adaptCollectionToApi(params)
    },
    resolver: adaptCollectionToStore,
  },
  {
    name: 'editCollection',
    method: 'put',
    url: (params) => `/collections/${params.collectionId}`,
    data: (params) => {
      return adaptCollectionToApi(params)
    },
    resolver: adaptCollectionToStore,
  },
  {
    name: 'getUploadedCollectionsCsv',
    method: 'get',
    url: () => `/collections-loader`,
  },
  {
    name: 'uploadCollectionCsv',
    method: 'post',
    url: () => `/collections-loader/load-file`,
    headersFactory: buildHeaders({
      'Content-Type': undefined,
    }),
    data: (params) => {
      return params.source
    },
  },
  {
    name: 'validateCollectionCsv',
    method: 'get',
    url: (params) => `/collections-loader/${params.csvId}/validate`,
  },
  {
    name: 'importCollectionCsv',
    method: 'post',
    url: (params) => `/collections-loader/${params.csvId}/import`,
  },
  {
    name: 'getLabManualID',
    method: 'get',
    url: (params) => `/argus/labs?pta_manual_id=${params.argusId}`,
  }
]

const contentServices = [
  {
    name: 'listLightCollections',
    method: 'get',
    url: (params) => `/collections${buildParamList(omitByEmptyKeepBooleans({ ...params, light: true }))}`,
    resolver: adaptCollectionsToStore,
  },
]

export const {
  getCollection,
  listCollections,
  createCollection,
  editCollection,
  getUploadedCollectionsCsv,
  uploadCollectionCsv,
  validateCollectionCsv,
  importCollectionCsv,
  getLabManualID,
} = buildServices(CONTENT_BACKOFFICE, services)

export const {
  listLightCollections,
} = buildServices(CONTENT, contentServices)
